﻿export class LPXLibProfit_v1ABI
{
    public static GetABI():any
    {
        return [
	{
		"inputs": [
			{
				"internalType": "uint256",
				"name": "poolId_",
				"type": "uint256"
			},
			{
				"internalType": "address",
				"name": "user_",
				"type": "address"
			}
		],
		"name": "getShareInfo",
		"outputs": [
			{
				"components": [
					{
						"internalType": "uint256",
						"name": "debt",
						"type": "uint256"
					},
					{
						"internalType": "uint256",
						"name": "pending",
						"type": "uint256"
					}
				],
				"internalType": "struct ILPXv1.ShareInfo",
				"name": "shareInfo_",
				"type": "tuple"
			},
			{
				"internalType": "uint256",
				"name": "pps_",
				"type": "uint256"
			}
		],
		"stateMutability": "view",
		"type": "function"
	}
];
    }
}